// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"LoadingOverlay_loadingWrapper__13B1M","ballScale":"LoadingOverlay_ballScale__22flN","ball-scale":"LoadingOverlay_ball-scale__1XFWQ"};